import React from "react";
import RenewableEnergyExport from "../Pages/Scope4/CarbonAvoidance/RenawableEnergyExports/list";
import LowCarbonProductUse from "../Pages/Scope4/CarbonAvoidance/LowCleanerAlternatives/list";
import InHouseOffsetProject from "../Pages/Scope4/CarbonOffsetting/InHouseOffset/InHouse/list";
import Offset from "../Pages/Scope4/CarbonOffsetting/Offset/list";
import Dashboard from "../Pages/Scope4/Dashboard/Dashboard";

export const Scope4Routes = [
  {
    path: "/scope4/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/scope4/renewable-energy-export/",
    element: <RenewableEnergyExport />,
  },
  {
    path: "/scope4/low-carbon-roduct/",
    element: <LowCarbonProductUse />,
  },
  {
    path: "/scope4/in-house-offset-project/",
    element: <InHouseOffsetProject />,
  },
  {
    path: "/scope4/offset-credit-purchase-tracking/",
    element: <Offset />,
  },
];
